import React from 'react';
import T, { t } from '../../common/components/T';
import { logOutFunction, rolesMenu } from '../../common/utils/utils';
import { getRoute, navigateV2, replaceUrl } from '../../common/utils/router';
import { A } from '../../hybrid/wrappers';

export const handleClick = (event, item, submenu, toggleMenu) => {
    if (!event.ctrlKey && event) {
        event.preventDefault();
    }

    if (item.type === 'part' && item.submenu.length && submenu) {
        return submenu(item);
    }
    if (item.name === 'logout') {
        return logOutFunction();
    }
    if (item.target) {
        window.open(
            item.type === 'link'
                ? replaceUrl(`${item.asLink}`)
                : item.type === 'outLink'
                ? `https://${item.asLink}`
                : item.type === 'page'
                ? replaceUrl(`/page${item.asLink}`)
                : ''
        );
        return false;
    }
    if (item.type === 'link') {
        toggleMenu && toggleMenu();
        return navigateV2(`${item.asLink}`);
    } else if (item.type === 'outLink') {
        document.location = `https://${item.asLink}`;
        return false;
    } else if (item.type === 'page') {
        toggleMenu && toggleMenu();
        return navigateV2(`/page${item.asLink}`);
    }
};
export const returnHref = (item) => {
    if (item.type === 'part' || item.name === 'logout') {
        return 'javascript:void(0)';
    }
    if (item.type === 'link') {
        return `${item.asLink}`;
    } else if (item.type === 'outLink') {
        return `https://${item.asLink}`;
    } else if (item.type === 'page') {
        return `/page${item.asLink}`;
    }
};

export const checkScrollButtons = (transform = 0, scrollElement, innerElement, setBottom, setTop) => {
    if (scrollElement?.offsetHeight < innerElement?.offsetHeight) {
        if (Math.ceil(-transform + scrollElement.offsetHeight) >= innerElement.offsetHeight) {
            setBottom(false);
        } else {
            setBottom(true);
        }
        if (transform < 0) {
            setTop(true);
        } else {
            setTop(false);
        }
    } else {
        setBottom(false);
        setTop(false);
    }
};
export const calcTransform = (plus, innerElement, scrollElement, transform) => {
    const difference = innerElement?.offsetHeight - scrollElement?.offsetHeight;
    return plus ? (transform + 200 >= 0 ? 0 : transform + 200) : -(transform - 200) >= difference ? -difference : transform - 200;
};
export const generateActives = (itemMenu, router, active) => {
    const path = active || getRoute(router.asPath);
    let actives = [];
    let subActives = [];

    itemMenu.forEach((item) => {
        if (item.asLink === path) {
            actives.push(item.name);
        }
        if (item.submenu?.length) {
            item.submenu.forEach((s) => {
                if (s.asLink === path) {
                    actives.push(item.name);
                    subActives.push(s.name);
                }
            });
        }
    });
    return {
        active: actives,
        subactive: subActives
    };
};
export const MenuLink = (props) => {
    if (props.type === 'part') {
        const filteredProps = Object.keys(props).reduce((acc, key) => {
            if (key !== 'childrenRef' && key !== 'type') {
                return { ...acc, [key]: props[key] };
            }
            return acc;
        }, {});
        return (
            <div {...filteredProps} ref={props.childrenRef}>
                {props.children}
            </div>
        );
    }
    return <A {...props}>{props.children}</A>;
};

const itemMenuChild = (submenu, data, lang) => {
    const accum = [];
    if (!!submenu.length) {
        submenu.map((childItem) => {
            const id = childItem._id;
            const childrenData = [];
            data.map((itemData) => {
                if (itemData.parent === id) {
                    childrenData.push(itemData);
                }
            });

            accum.push({
                ...childItem,
                title: childItem.title[lang] || childItem.title.default,
                icon: childItem.icon || (childItem.type === 'part' ? 'menu-category' : 'menu-file'),
                name: childItem._id + '-name',
                asLink: !!childItem.link ? childItem.link : childItem._id + '_link',
                submenu: itemMenuChild(childrenData, data, lang)
            });
        });
    }
    return accum;
};

export const getItemMenu = (data, roles, lang, outerPart, translation, profileData, waitForProfileLoaded) => {
    const menu = [];
    if (waitForProfileLoaded && !profileData) return menu;
    if (profileData && !roles?.length) return menu;
    if (data && !!data?.length) {
        const filtered = rolesMenu(data, roles, profileData);
        const sorted = filtered.sort((a, b) => a.order - b.order);
        const parent = sorted.find((element) => element.parent === '')?._id;

        sorted.map((item) => {
            if (item.parent === parent) {
                const id = item._id;
                const submenu = [];
                sorted.map((itemChild) => {
                    if (itemChild.parent === id) {
                        submenu.push(itemChild);
                    }
                });

                menu.push({
                    ...item,
                    title: item.title[lang] || item.title.default,
                    icon: item.icon,
                    name: item._id + '-name',
                    submenu: itemMenuChild(submenu, sorted, lang),
                    asLink: !!item.link ? item.link : item._id + '_link'
                });
            }
        });
    }
    if (outerPart) {
        menu.push({
            activity: true,
            asLink: '/logout',
            icon: 'menu-logout',
            name: 'logout',
            roles: [],
            showAll: true,
            target: false,
            type: 'link',
            linkNative: 'Home',
            title: translation ? (
                t('logoutTitle', 'Выйти', 'all', translation)
            ) : (
                <T textName='logoutTitle' defaultStr='Выйти' page='all' />
            ),
            submenu: []
        });
    }
    return menu;
};

export const bottomMenuOfficeData = [
    {
        name: 'orders',
        asLink: '/orders',
        icon: 'menu-orders',
        title: <T textName='orderTitle' defaultStr='Заказы' page='/office' />
    },
    {
        name: 'treegraph',
        asLink: '/treegraph',
        icon: 'menu-structure',
        title: <T textName='structureTitle' defaultStr='Структура' page='/office' />
    },
    {
        name: 'office',
        asLink: '/office',
        icon: 'menu-office',
        title: <T textName='officeTitle' defaultStr='Кабинет' page='all' />
    },
    {
        name: 'wallets',
        asLink: '/wallets',
        icon: 'menu-wallets',
        title: <T textName='walletsTitle' defaultStr='Счета' page='/office' />
    },
    {
        name: 'reports',
        asLink: '/reports',
        icon: 'menu-report',
        title: <T textName='reportsTitle' defaultStr='Отчеты' page='/office' />
    }
];
